// ==================================================== BUTTONS CLOSE COOKIES======================================================
/*
========================================== Close message cookies =========================================

● This IIFE function checks if the localstorage has the variable "closeMessage" with a value of true.
● If the value is true, the cookies message will no longer be displayed on the screen.
● In order for the message to be displayed again, it is necessary to delete the cookies from the browser.
● The variable "closeMessage" in localstorage will take the value of true when the event is executed by pressing the x of the alert.
===============================================================================================================*/

'use strict';

/**
 * Manages the cookies consent message visibility
 */
module.exports = {
    init: function() {
        try {
            const popupCheckout = document.getElementById("modal-check");
            const btnCloseMessageCookies = document.querySelector(".checkout-alert-register-card-close");
            
            if (!popupCheckout || !btnCloseMessageCookies) {
                console.warn("Necessary elements for cookies message not found");
                return;
            }
            
            const isClosed = localStorage.getItem("closeMessage") === "true";
            
            if (isClosed) {
                popupCheckout.classList.add("d-none");
            } else {
                popupCheckout.classList.remove("d-none");
            }
            
            btnCloseMessageCookies.addEventListener("click", function () {
                localStorage.setItem("closeMessage", "true");
                popupCheckout.classList.add("d-none");
            });
        } catch (error) {
            console.error("Error in cookies message management:", error);
        }
    }
};